import { render, staticRenderFns } from "./Brand.vue?vue&type=template&id=4be32774&"
import script from "./Brand.vue?vue&type=script&lang=js&"
export * from "./Brand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4be32774')) {
      api.createRecord('4be32774', component.options)
    } else {
      api.reload('4be32774', component.options)
    }
    module.hot.accept("./Brand.vue?vue&type=template&id=4be32774&", function () {
      api.rerender('4be32774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/brand/Brand.vue"
export default component.exports